import { Text } from 'braid-design-system';
import { formatMinorUnits } from '@seek/currency';
import { useAppContext } from 'src/App/context/AppContext';
import type { MappedAdProduct } from 'src/mappers/mapProductSetItems';
import {
  isNetPriceEqualToRetailPrice,
  getPriceBeforeDiscountWithTax,
} from '../getDisplayPrices';

export const Discount = ({
  mappedAdProduct,
  showDiscountInfo,
}: {
  mappedAdProduct: MappedAdProduct;
  showDiscountInfo: boolean;
}) => {
  const { language } = useAppContext();
  const { price, name } = mappedAdProduct;

  if (!showDiscountInfo || isNetPriceEqualToRetailPrice(price)) {
    return null;
  }

  const priceBeforeDiscount = getPriceBeforeDiscountWithTax(price);

  return (
    <Text
      id={`${name}_price_before_discount`}
      data={{ testid: `${name}_price_before_discount` }}
      size="small"
      component="s"
    >
      {formatMinorUnits(priceBeforeDiscount, {
        currency: price?.retailPrice.currency,
        locale: language,
      })}
    </Text>
  );
};
